import { BlocksIconArrowBack } from 'blocks-nextjs/blocks-web-components/components/icon/icons/arrow-back';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconArrowBack = createComponent({ react: React, tagName: 'cat-icon-arrow-back', elementClass: BlocksIconArrowBack });
